
import React, { useEffect } from 'react';
import { useToken } from "./token_context";
import { useMessage } from "./message_context";
import { usePageContext } from "./page_context";
import { OKCancelDialog } from "./util/ok_cancel_dialog";
import { getParameters } from "./util/parameters";


import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from "yup";


async function submitSession(access_token, values) {
    const payload = {
        _t: access_token.token,
        data: values
    };
    const res = await fetch("/api/model/sessions",
        {
          "method": "POST",
          "body": JSON.stringify(payload)
        });

    const res_data = await res.json();
    return res_data;
};

export function SubmitSessionForm(props) {
    const { token } = useToken();
    const { setMessage, setError } = useMessage();
    const { page_state, setPageState } = usePageContext();
    const [ send_confirm_open, setSendConfirmOpen ] = React.useState(false);
    const [ durations, setDurations ] = React.useState([]);
    const [ form_message, setFormMessage ] = React.useState([]);

    const initialValues = {
        title: "",
        author: "",
        duration: null
    }

    const validationSchema = Yup.object({
      title: Yup.string().required("Required").max(45, 'Max 45 chars'),
      author: Yup.string().required("Required").max(23, 'Max 23 chars'),
      duration: Yup.string().required("Required"),
    });

    async function fetchDurations() {
        const data = await getParameters(token, "config", "durations");
        setDurations(data);
    };

    useEffect(() => {
        fetchDurations();
    }, [ token ]);

    const FormikListener = ({ values, callback }) => {
      useEffect(() => {
        callback(values);
      }, [callback, values]);

      return null;
    };

    function handleOnChange(values) {
        if (values.title) {
            setFormMessage("");
        };
    };

    if (token.permissions.includes("can_submit_session") && page_state.submit_session_active) {
        return (
<div>
    <Formik initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting, resetForm, setFieldValue }) => {
                if (!send_confirm_open) {
                    setSendConfirmOpen(true);
                } else {
                    submitSession(token, values).then((rc) => {
                        setSendConfirmOpen(false);
                        console.log(rc);
                        if (rc.rc == "ok") {
                            const author = values.author;
                            resetForm();
                            setFieldValue("author", author);
                            setMessage("Thank you! Session submitted.");
                            setFormMessage("Thank you! Session submitted.");
                        } else if (rc.rc == "not_permitted") {
                            setError("Session pitching has ended. Can not submit new sessions!");
                        } else {
                            setError("Error while submitting. Please try again later...");
                        };
                        setSubmitting(false);
                   });
               };
            }}>
        {({ values, errors, touched, isSubmitting, setFieldValue, handleSubmit }) => {

            return (
      <Form>
           <FormikListener values={values} callback={handleOnChange} />

              <div className="">
                <h3 className="font-bold text-lg py-2">Submit Your Pitch</h3>


              <div className="relative z-0 w-full mb-5 group">
                  <label for="title"
                         className="block mb-2.5 text-sm font-medium text-heading">
                         Session Title
                 </label>
                  <Field type="text"
                         name="title"
                         className="bg-neutral-secondary-medium border border-default-medium text-heading text-sm rounded-base focus:ring-brand focus:border-brand block w-full p-3.5 shadow-xs placeholder:text-body"
                         placeholder="I want to talk about..." />
                  <ErrorMessage name="title" component="div" className="text-red-600 font-bold" />
              </div>

              <div className="relative z-0 w-full mb-5 group">
                  <label for="author"
                         className="block mb-2.5 text-sm font-medium text-heading">
                         Your Name
                 </label>
                  <Field type="text"
                         placeholder="My name is..."
                         name="author"
                         className="bg-neutral-secondary-medium border border-default-medium text-heading text-sm rounded-base focus:ring-brand focus:border-brand block w-full p-3.5 shadow-xs placeholder:text-body"
                         />
                  <ErrorMessage name="author" component="div" className="text-red-600 font-bold" />
              </div>

             <label for="type" className="block mb-2.5 text-sm font-medium text-heading">Estimated Duration</label>
             <Field name="duration"
                     as="select"
                     value={values.duration || ""}
                     className="block w-full px-3 py-2.5 bg-neutral-secondary-medium border border-default-medium text-heading text-sm rounded-base focus:ring-brand focus:border-brand shadow-xs placeholder:text-body">
                <option value="">Choose duration</option>
                { durations.map((duration) => (
                    <option value={ duration }>approx. {duration} min</option>
                ))}
              </Field>
              <ErrorMessage name="duration" component="div" className="text-red-600 font-bold" />


                <div className="modal-action flow-root">
                    <button className="btn btn-secondary mx-2 float-right">Submit</button>
                </div>
              </div>


            {send_confirm_open && <OKCancelDialog open={send_confirm_open} title="One more step..."
                             content="Please click 'OK' to submit your session."
                             handleOK={() => {
                                 handleSubmit();
                             }}
                             handleCancel={() => {
                                 setSendConfirmOpen(false);
                             }}/>}

            { form_message && <div className="m-4 text-center bg-gray-200 p-4 text-2xl">{form_message}</div> }
      </Form>
    );}}
    </Formik>
</div>
    );
    }
};

